import { useEffect, useState } from 'react';

import { useGlobalDialog } from "../../Store/DialogManager";

import { useSnackbar } from "notistack";
import styled from 'styled-components';
import { Parser } from 'html-to-react';
import {
    Typography,
} from "@mui/material";

import { useNewsHook } from '../../Hooks/Dashboard/newsHooks';

import { AddEditViewNewsModalInterface, NewsItem } from '../../Models/Dashboard/News';

import QueryBuilderHelper from '../../Utilities/Helpers/QueryBuilderHelper';
import DateHelper from '../../Utilities/Helpers/DateHelper';
import RequiredFieldHelper from '../../Utilities/Helpers/RequiredFieldHelper';
import RequiredParametersHelper from '../../Utilities/Helpers/RequiredParametersHelper';

import { ButtonType } from '../../Utilities/Enums/ButtonTypeEnum';
import { CachingEnum } from '../../Utilities/Enums/CachingEnum';
import { FileSizeType } from '../../Utilities/Enums/FileEnum';
import { ViewType } from '../../Utilities/Enums/ViewTypeEnum';
import { NewsItemField } from '../../Utilities/Enums/ParametersEnum';

import CustomButton from '../../CustomViews/Elements/CustomButton';

import FormTextField from '../../CustomViews/Elements/FormTextField';
import FormDatePicker from '../../CustomViews/Elements/FormDatePicker';
import FormRichTextEditor from '../../CustomViews/Elements/FormRichTextEditor';
import FormFilePicker from '../../CustomViews/Elements/FormFilePicker';

const ModalContentContainer = styled.div <{ $darkMode?: boolean; }>`
    width: 40vw;

    .coverPhotoContainer {
        width: -webkit-fill-available;
        height: 250px;
        text-align: center;

        img {
            // object-fit: cover;
            // width: 100%;
            object-fit: unset !important;
            width: unset !important;
            height: 100%;
        }
    }
`;

const PreviewContainer = styled.div <{ $darkMode?: boolean; }>`
    .coverPhotoContainer {
        width: -webkit-fill-available;
        height: 40vh;
        text-align: center;

        img {
            // object-fit: cover;
            // width: 100%;
            object-fit: unset !important;
            width: unset !important;
            height: 100%;
        }
    }

    .newsName {
        font-size: 1.75rem;
        font-weight: 600 !important;
    }

    .newsDate {
        font-size: 13px !important;
        font-weight: 400;
        color: #878a99;
    }

    .newsContentContainer {
        margin: 30px 0px 0px 0px;

        font-size: 14px !important;
        font-weight: 400 !important;
    }
`;

const FormContainer = styled.div <{ $darkMode?: boolean; }>`
    display: grid;
    grid-template-columns: 1fr;
    gap: 15px;

    .customDatePicker {
        width: -webkit-fill-available;

        .MuiStack-root {
            width: -webkit-fill-available;

            .MuiFormControl-root.MuiTextField-root,
            .MuiFormControl-root.MuiPickersTextField-root {
                width: -webkit-fill-available;
            }
        }
    }

    .coverPhotoContainer {
        width: -webkit-fill-available;
        height: 40vh;

        img {
            object-fit: cover;
            width: 100%;
            height: 100%;
        }
    }
`;

export default function AddEditViewNewsModal(props: AddEditViewNewsModalInterface) {
    let { openAddEditViewNewsModal, setopenAddEditViewNewsModal, viewType, setviewType, newsPublicId, setnewsPublicId } = props;
    const { enqueueSnackbar } = useSnackbar();
    const { setDialogContent, setOpenGlobalDialog } = useGlobalDialog();
    let requiredFields = RequiredParametersHelper.news();

    //Use States
    const [queryStr, setQueryStr] = useState({
        pageSize: QueryBuilderHelper.DefaultPageSizeValue(),
        pageNumber: QueryBuilderHelper.DefaultPageNumValue(),
        searchString: QueryBuilderHelper.DefaultSearchValue(),
    });
    let [formData, setformData] = useState<NewsItem>(new NewsItem());
    let [errorMessages, setErrorMessages] = useState<any>({});

    const q_queryKey = [CachingEnum.NEWS, queryStr]
    const { getNewsById, getNewsCoverPhotoById, createNews, editNewsById } = useNewsHook(q_queryKey, queryStr, false);

    //Variables
    const subjectProps = {
        name: NewsItemField.NAME,
        title: 'Subject',
        fieldValue: formData?.[NewsItemField.NAME] ?? "",
        type: 'text',
        required: requiredFields?.find((field: any) => field.keyName == NewsItemField.NAME)?.keyName != null,
        errorMessages: errorMessages,
        handleOnChange: (selectedValue: any) => {
            setformData((prev: any) => ({ ...prev, [NewsItemField.NAME]: selectedValue }));
        },
    },
        dateProps = {
            name: NewsItemField.DATE,
            title: 'Date',
            fieldValue: formData?.[NewsItemField.DATE] ?? null,
            required: requiredFields?.find((field: any) => field.keyName == NewsItemField.DATE)?.keyName != null,
            errorMessages: errorMessages,
            handleOnChange: (selectedValue: any) => {
                setformData(prev => ({ ...prev, [NewsItemField.DATE]: selectedValue ?? null }));
            },
        },
        descriptionProps = {
            name: NewsItemField.DESCRIPTION,
            title: "Description",
            fieldValue: formData?.[NewsItemField.DESCRIPTION] ?? "",
            required: requiredFields?.find((field: any) => field.keyName == NewsItemField.DESCRIPTION)?.keyName != null,
            errorMessages: errorMessages,
            handleOnChange: (selectedValue: any) => {
                setformData((prev: any) => ({ ...prev, [NewsItemField.DESCRIPTION]: selectedValue }));
            }
        },
        fileProps = {
            name: NewsItemField.COVER_IMAGE,
            title: 'Upload Cover Image',
            subLabel: "Recommended file format: JPG/JPEG/PNG format with 800 x 600 pixels, maximum file size up to 5MB",
            acceptedFileTypes: ['image/apng', 'image/avif', 'image/gif', 'image/jpeg', 'image/png', 'image/svg+xml', 'image/webp'],
            maxFileSize: 100,
            fileSizeType: FileSizeType.MB,
            // deleteFile: (viewType == ViewType.EDIT ?
            deleteFile: (formData?.[NewsItemField.COVER_IMAGE_SRC] ?
                () => {
                    setformData((prev: any) => ({ ...prev, [NewsItemField.COVER_IMAGE]: null, [NewsItemField.COVER_IMAGE_SRC]: null, [NewsItemField.IS_COVER_CHANGE]: true }));
                } : null
            ),
            handleOnChange: (selectedFile: any, previewSelectedFile: any) => {
                setformData((prev: any) => ({ ...prev, [NewsItemField.COVER_IMAGE]: selectedFile, [NewsItemField.COVER_IMAGE_SRC]: previewSelectedFile, [NewsItemField.IS_COVER_CHANGE]: true }));
            },
        };

    //Event Handlers
    const getNewsData = async () => {
        let _formData = {...formData};

        if(newsPublicId) {
            let getDetails = await getNewsById(newsPublicId);
            let _imgURL: any = '';

            // if(getDetails?.data?.[NewsItemField.HAS_COVER_IMAGE]) {
                const responseData: any = await getNewsCoverPhotoById(getDetails?.data?.[NewsItemField.PUBLIC_ID]);

                _imgURL = responseData?.data ?? null;
            // }

            _formData = {...formData, ...getDetails?.data, [NewsItemField.COVER_IMAGE_SRC]: _imgURL};
        }

        setformData(_formData);
    }
    
    const handleSubmit = async () =>{
        let _validateForm = RequiredFieldHelper.validateForm(requiredFields, formData, errorMessages, setErrorMessages, enqueueSnackbar);

        if (_validateForm?.hasError) { return true; }

        let _success: boolean = false;
        let _formData: any = new FormData();
        let _newsPublicId: string | number = formData?.[NewsItemField.PUBLIC_ID] ?? "";

        _formData.append([NewsItemField.NAME], formData?.[NewsItemField.NAME]);
        _formData.append([NewsItemField.DATE], formData?.[NewsItemField.DATE]);
        _formData.append([NewsItemField.DESCRIPTION], formData?.[NewsItemField.DESCRIPTION]);
        _formData.append([NewsItemField.COVER_IMAGE], formData?.[NewsItemField.COVER_IMAGE]);
        _formData.append([NewsItemField.IS_COVER_CHANGE], formData?.[NewsItemField.IS_COVER_CHANGE]);
        _formData.append([NewsItemField.STATUS], formData?.[NewsItemField.STATUS]);

        if(!_newsPublicId) {
            let createResponse = await createNews(_formData);
            _success = createResponse?.isSuccess ?? false;
        } else {
            let editResponse = await editNewsById(_newsPublicId, _formData);
            _success = editResponse?.isSuccess ?? false;
        }


        if(_success) {
            onCloseDialog();
        }
    }

    const onCloseDialog = async (e: any = null) => {
        if(e) {
            e.preventDefault();
        }

        if(setopenAddEditViewNewsModal) {
            setopenAddEditViewNewsModal(false);
        }


        if(setviewType) {
            setviewType(ViewType.ADD);
        }

        if(setnewsPublicId) {
            setnewsPublicId('');
        }

        setOpenGlobalDialog(false);
    }

    useEffect(() => {
        if(openAddEditViewNewsModal) {
            setDialogContent({
                title: viewType == ViewType.PREVIEW ? "News Details" : (viewType == ViewType.EDIT ? "Edit" : "Add") + " News",
                clearDialog: onCloseDialog,
                onCloseDialog: onCloseDialog,
                actionButtons: viewType != ViewType.PREVIEW ? renderActionButtons() : null,
                children: renderDialogContent(),
            });
        }
    }, [openAddEditViewNewsModal, formData, errorMessages]);

    useEffect(() => {
        if(newsPublicId) {
            getNewsData();
        }
    }, [newsPublicId]);

    //Rendering Functions
    const renderActionButtons = () => {
        return <>
            <CustomButton
                btnType={ButtonType.CANCEL}
                title='Close'
                onClick={(e: any) => {
                    onCloseDialog(e);
                }} />

            <CustomButton
                btnType={ButtonType.SUCCESS}
                title='Save'
                onClick={(e: any) => {
                    handleSubmit();
                }} />
        </>
    }

    const renderPreviewNews = () => {
        return <PreviewContainer>
            {formData?.[NewsItemField.COVER_IMAGE_SRC] && <div className="coverPhotoContainer">
                <img className="" src={formData?.[NewsItemField.COVER_IMAGE_SRC]} />
            </div>}
            <Typography className="newsName">{formData?.[NewsItemField.NAME] ?? "--"}</Typography>
            {formData?.[NewsItemField.DATE] && <Typography className="newsDate">{DateHelper.getFormattedDate(formData?.[NewsItemField.DATE], "dd Month, yyyy")}</Typography>}

            <div className="newsContentContainer">
                {formData?.[NewsItemField.DESCRIPTION] ? Parser().parse(formData?.[NewsItemField.DESCRIPTION]) : "---"}
            </div>
        </PreviewContainer>
    }

    const renderNewsForm = () => {
        return <FormContainer>
            <FormTextField {...subjectProps} />
            <FormDatePicker {...dateProps} />
            <FormRichTextEditor {...descriptionProps} />
            <FormFilePicker {...fileProps} />

            {formData?.[NewsItemField.COVER_IMAGE_SRC] && <div className="coverPhotoContainer">
                <img src={formData?.[NewsItemField.COVER_IMAGE_SRC]} />
            </div>}
        </FormContainer>
    }

    const renderDialogContent = () => {
        return <ModalContentContainer>
            {viewType == ViewType.PREVIEW && renderPreviewNews()}
            {viewType != ViewType.PREVIEW && renderNewsForm()}
        </ModalContentContainer>
    }

    return <></>
}